import { useState, useEffect } from 'react';
import { FiClock } from 'react-icons/fi';
import { releaseNotesData } from './releaseNotesData';
import { getVersionHistory } from '../../api/api';

interface Props {
  onClick: () => void;
  collapsed?: boolean;
}

export default function VersionBadge({ onClick, collapsed }: Props) {
  const [currentVersion, setCurrentVersion] = useState<string>(releaseNotesData[0]?.version || "v2.4.0");

  useEffect(() => {
    let isMounted = true;
    getVersionHistory()
      .then((res: any) => {
        if (isMounted && res.data?.data && res.data.data.length > 0) {
          setCurrentVersion(res.data.data[0].version);
        }
      })
      .catch(() => {
        // Silently use static fallback
      });

    return () => {
      isMounted = false;
    };
  }, []);

  if (collapsed) {
    return (
      <button
        onClick={onClick}
        className="w-9 h-9 rounded-full flex items-center justify-center text-gray-400 hover:text-[#B08D55] hover:bg-[#B08D55]/10 transition-colors cursor-pointer group"
        title={`Updates ${currentVersion}`}
        aria-label={`View Updates ${currentVersion}`}
      >
        <FiClock size={16} className="group-hover:rotate-12 transition-transform text-[#B08D55]" />
      </button>
    );
  }

  return (
    <button
      onClick={onClick}
      className="w-full py-1 text-xs text-gray-400 hover:text-[#B08D55] transition-colors flex items-center justify-center gap-1.5 cursor-pointer group select-none"
      title="View Product Updates & Release Notes"
    >
      <FiClock size={12} className="text-gray-400 group-hover:text-[#B08D55] group-hover:rotate-12 transition-all shrink-0" />
      <span className="text-[11px] font-medium tracking-wide">Updates {currentVersion}</span>
    </button>
  );
}
